import React from 'react';
import { Alert, Empty, List, Space, Spin, Tag, Typography } from 'antd';
import { useRegulatoryAlertsByEquipo } from 'providers/RegulatoryAlerts';

const { Text } = Typography;

const SEVERITY_COLORS = {
  critical: 'red',
  warning: 'orange',
  info: 'blue',
};

const TIPO_LABELS = {
  certificacion_vence: 'Certificación por vencer',
  certificacion_vencida: 'Certificación vencida',
  mantencion_mensual_faltante: 'Mantención mensual faltante',
  datos_incompletos: 'Datos incompletos',
};

// Lista de alertas regulatorias activas de un equipo. Usado dentro del
// EquipoDetailDrawer, tab "Alertas". Lee GET /equipos/:id/alerts.
function AlertasEquipo({ idEquipo }) {
  const { alerts, loading, error, refresh } = useRegulatoryAlertsByEquipo(idEquipo);

  if (loading) {
    return (
      <Space style={{ width: '100%', justifyContent: 'center', padding: 24 }}>
        <Spin />
      </Space>
    );
  }

  if (error) {
    return (
      <Alert
        type="error"
        showIcon
        message="No se pudieron cargar las alertas"
        description={error?.message ?? 'Reintentá más tarde.'}
        action={<a onClick={() => refresh()}>Reintentar</a>}
      />
    );
  }

  if (!alerts || alerts.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Sin alertas regulatorias activas para este equipo"
      />
    );
  }

  return (
    <List
      dataSource={alerts}
      rowKey={(a) => a.id}
      renderItem={(a) => (
        <List.Item>
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Space wrap>
              <Tag color={SEVERITY_COLORS[a.severidad] ?? 'default'}>
                {String(a.severidad).toUpperCase()}
              </Tag>
              <Text strong>{TIPO_LABELS[a.tipo] ?? a.tipo}</Text>
              {a.fecha_relevante && (
                <Text type="secondary">
                  {new Date(a.fecha_relevante).toISOString().slice(0, 10)}
                </Text>
              )}
            </Space>
            <Text>{a.mensaje}</Text>
          </Space>
        </List.Item>
      )}
    />
  );
}

export default AlertasEquipo;
